import Box from '@mui/material/Box';
import { useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { mapCountry } from 'tdc-web-backend/enums/enums';
import { Stack } from '@mui/material';
import { FormProvider, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { initialState } from './utils';
import useCreate from '../../../utils/hooks/crud-hooks/useCreate';
import { DASHBOARD_WRAPPER_PADDING } from '../../Dashboard/Main';
import useAuth from '../../../utils/hooks/useAuth';
import BaseInputLabel from '../../../components/custom-inputs/BaseInputLabel';
import CustomInput from '../../../components/custom-input/CustomInput';
import { secondaryBlue } from '../../../utils/color';
import ControlledTextEditor from '../../../components/custom-inputs/ControlledTextEditor';
import { TimedProjectEditorMenu } from '../../../components/editor/menu-option-lists/menu-item-lists';
import ControlledTextInput from '../../../components/custom-inputs/ControlledTextInput';
import CustomButton from '../../../components/button/CustomButton';

export const labels = [''];

const PostRegistration = () => {
  const [isLoading, setIsLoading] = useState(false);
  const { mutate: create } = useCreate({ resource: 'companies' });
  const { t } = useTranslation();
  const navigate = useNavigate();
  const {
    authData: { userData: user },
    updateUser,
  } = useAuth();

  const membership = user?.membership;

  const form = useForm({
    defaultValues: initialState,
    mode: 'onChange',
  });

  useEffect(() => {
    // if a user HAS company tied to him, don't let them get to create-company
    if (membership !== null && membership !== undefined) navigate('/dashboard');
  }, [membership, navigate]);

  const onSubmit = (data: any) => {
    setIsLoading(true);

    create(
      {
        ...data.overview,
      },
      {
        onSuccess: () => {
          updateUser(
            { jobTitle: data.admin.jobTitle },
            {
              onSuccess: () => {
                setIsLoading(false);
              },
              onError: () => {
                setIsLoading(false);
              },
            },
          );
        },
        onError: () => {
          setIsLoading(false);
        },
      },
    );
  };
  return (
    <Box sx={{ width: '70%', p: `${DASHBOARD_WRAPPER_PADDING}px` }}>
      <FormProvider {...form}>
        <form
          style={{
            display: 'flex',
            flexDirection: 'column',
          }}
          onSubmit={form.handleSubmit(onSubmit)}
        >
          <Stack spacing={3}>
            <BaseInputLabel text={t('postRegistration.companyOverview')} />
            <Stack flexDirection="row" sx={{ margin: '0 0 32px 0' }}>
              <Stack
                spacing={3}
                flex={1}
                sx={{ padding: '0 24px 0 0', borderRight: `1px solid ${secondaryBlue[100]}` }}
              >
                <CustomInput
                  input={<CustomInput.Text />}
                  name="overview.name"
                  placeholder={`${t('common.add')} ${t('common.companyName')}`}
                  label={t('common.companyName')}
                  required
                />

                <CustomInput
                  input={<CustomInput.Text />}
                  name="overview.url"
                  placeholder={`${t('common.add')} ${t('common.companyWebsite')}`}
                  label={t('common.companyWebsite')}
                  required
                />
              </Stack>

              <Stack spacing={3} flex={1} sx={{ padding: '0 0 0 24px' }}>
                <BaseInputLabel
                  text={t('settings.companyProfile.overviewDetails.headquartersLocation')}
                  sx={{
                    padding: '0 0 12px 0',
                    margin: '0 0 24px 0',
                    borderBottom: `1px solid ${secondaryBlue[100]}`,
                    mb: '0px !important',
                  }}
                />

                <CustomInput
                  input={<CustomInput.Autocomplete />}
                  name="overview.headquartersLocation.country"
                  choices={mapCountry}
                  translation={{ t, ns: 'enum' }}
                  placeholder={t('common.selectCountry')}
                  label={t('common.country')}
                  required
                />

                <CustomInput
                  input={<CustomInput.Text />}
                  name="overview.headquartersLocation.city"
                  placeholder={`${t('common.add')} ${t('common.city')}`}
                  label={t('common.city')}
                  required
                />
              </Stack>
            </Stack>

            <ControlledTextEditor
              label={t('postRegistration.companyDescription')}
              name="overview.description"
              items={TimedProjectEditorMenu}
              required
            />
            <BaseInputLabel text={t('postRegistration.accountAdministrator')} />
            <Stack flexDirection="row" mt={1}>
              <Stack
                width="100%"
                pr={3}
                sx={{ borderRight: '1px solid', borderColor: 'secondaryBlue.100' }}
              >
                <ControlledTextInput
                  name="admin.email"
                  placeholder={user?.email}
                  label={t('postRegistration.userEmail')}
                  disabled
                />
              </Stack>

              <Stack width="100%" pl={3}>
                <CustomInput
                  input={<CustomInput.Text />}
                  name="admin.jobTitle"
                  placeholder={`${t('common.enter')} ${t('postRegistration.jobTitle')}`}
                  label={t('postRegistration.jobTitle')}
                  required
                />
              </Stack>
            </Stack>
            <Stack direction="row" justifyContent="flex-end" spacing={2} sx={{ mt: 4 }}>
              <CustomButton key="submit" variant="primary" type="submit" loading={isLoading}>
                {t('common.submit')}
              </CustomButton>
            </Stack>
          </Stack>
        </form>
      </FormProvider>
    </Box>
  );
};

export default PostRegistration;
